import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `LineaGenetica/addLineaGenetica`, method: 'POST', body: values, token: token})
}
